export default {
    '$route': function() {
        const self = this

        self.symplaToken = {}
        self.resetFormResult()
    }
}
